import { render, staticRenderFns } from "./Notation.vue?vue&type=template&id=f80a02c6"
import script from "./Notation.vue?vue&type=script&lang=js"
export * from "./Notation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports